// For your convenience. Note that there are other regions; see the sealing service database or check the "Seals &
//   Signatures" tab in Paragon Accounts for a full list.
const ALL_STATES_AND_DC = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

const DEMO_REGIONS = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Florida', 'Tennessee', 'Wisconsin'];

const DANSCO_ENGINEERING = [
  'Alabama',
  'Delaware',
  'Florida',
  'Georgia',
  'Indiana',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maryland',
  'Michigan',
  'Mississippi',
  'Missouri',
  'New Jersey',
  'North Carolina',
  'Ohio',
  'Pennsylvania',
  'South Carolina',
  'Tennessee',
  'Texas',
  'Virginia',
  'West Virginia',
];

//Bill is with Monta Consulting & Design, but this is his personal list
const WILLIAM_RANIERI = [
  'Alabama',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Illinois',
  'Indiana',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Mississippi',
  'Missouri',
  'New Hampshire',
  'New Jersey',
  'New York',
  'North Carolina',
  'Ohio',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'Tennessee',
  'Texas',
  'Vermont',
  'Virginia',
  'West Virginia',
];

//This list goes beyond the regions on their site, but that is because they clearly invite requests outside their list of regions, which they can fulfill "through [their] affiliates"
const PE_ROBBINS = [
  'Alabama',
  'Alaska',
  'Arizona',
  'Arkansas',
  'California',
  'Colorado',
  'Connecticut',
  'Delaware',
  'District of Columbia',
  'Florida',
  'Georgia',
  'Hawaii',
  'Idaho',
  'Illinois',
  'Indiana',
  'Iowa',
  'Kansas',
  'Kentucky',
  'Louisiana',
  'Maine',
  'Maryland',
  'Massachusetts',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Missouri',
  'Montana',
  'Nebraska',
  'Nevada',
  'New Hampshire',
  'New Jersey',
  'New Mexico',
  'New York',
  'North Carolina',
  'North Dakota',
  'Ohio',
  'Oklahoma',
  'Oregon',
  'Pennsylvania',
  'Rhode Island',
  'South Carolina',
  'South Dakota',
  'Tennessee',
  'Texas',
  'Utah',
  'Vermont',
  'Virginia',
  'Washington',
  'West Virginia',
  'Wisconsin',
  'Wyoming',
];

const FIELDSTONE = [
  'Alabama',
  'California',
  'Colorado',
  'Florida',
  'Georgia',
  'Idaho',
  'Kentucky',
  'Maryland',
  'Michigan',
  'Minnesota',
  'Mississippi',
  'Nevada',
  'North Carolina',
  'Oregon',
  'Pennsylvania',
  'South Carolina',
  'Tennessee',
  'Texas',
  'Washington',
  'West Virginia',
];

const FIELDSTONE_ENG = ['Florida'];

// Configures which organizations are allowed to seal in which states; used by the design client to control how region
//   filtering works in the "Request Seals" / "Request Repair" dialog. Once the ideal behavior for this feature becomes
//   clear, please move this information into the database and make it editable in the Accounts client.
//
// Note: adding an organization here will not cause it to appear as a valid choice when sharing jobs or requesting
//   seals. The list of avaliable organizations to share with can be different per customer organization, and is
//   controlled by the `visibleOrganizations` field in the database.
export const ENGINEERING_ORGANIZATION_REGION_DEFINITIONS: { [organizationName: string]: string[] } = {
  'Develop Stamping Org': ALL_STATES_AND_DC, // for testing in develop and localhost
  'Production Demo': DEMO_REGIONS,
  'Design Demo': DEMO_REGIONS,
  'Dansco Engineering': DANSCO_ENGINEERING,
  'PE Robbins Engineering': PE_ROBBINS,
  'Monta Consulting & Design': WILLIAM_RANIERI,
  'Fieldstone Architecture and Engineering': FIELDSTONE,
  'Fieldstone Engineering': FIELDSTONE_ENG,
  'Dayhoff Structural PLLC': ALL_STATES_AND_DC,
} as const;
